import * as Sentry from '@sentry/react';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE, // 'production' or 'development'
    release: import.meta.env.VITE_GIT_SHA ?? 'unknown',

    // Performance: sample 10% of transactions (stay within 10K free limit)
    tracesSampleRate: 0.1,

    // Filter out noisy errors that burn through quota
    ignoreErrors: [
      // Network errors — expected when user goes offline
      'NetworkError',
      'Network request failed',
      'Failed to fetch',
      // Supabase auth — token refresh failures are expected
      'AuthApiError',
      // Chunk load errors — happen after deploys, fixed by reload
      'ChunkLoadError',
      'Loading CSS chunk',
      // Browser extensions
      'Non-Error promise rejection captured',
    ],

    // Don't send events in development
    beforeSend(event) {
      if (event.environment === 'development') return null;
      return event;
    },
  });
}
